export const Sizes = {
  DRAWER_WIDTH: 275,
  DRAWER_LEFT_PADDING: 25,
  DRAWER_LEFT_BORDER: 6,
  DRAWER_ITEM_SPACING: 25,
};
